import React from 'react';
import { planoCarro, planoMotocicleta } from './planosBeneficios';

const moeda = (v) => {
  const n = parseFloat(v);
  return isNaN(n) ? '-' : n.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
};

// Versão compacta do ModeloCotacao
export function CotacaoResumo({ veiculo, valorMensal, onConcordo }) {
  const beneficios = veiculo?.tipo === 'motocicleta' ? planoMotocicleta : planoCarro;

  return (
    <div style={{ width: '95vw', maxWidth: '450px', maxHeight: 'calc(100vh - 220px)', overflowY: 'auto', background: '#2b2b2b', color: '#fff', borderRadius: '8px', padding: '10px', fontSize: '12px', boxSizing: 'border-box' }}>
      <div style={{ textAlign: 'center', marginBottom: '8px' }}>
        <strong>{veiculo?.modelo}</strong>
        <div>PLACA: <strong>{veiculo?.placa}</strong> · FIPE: <strong>{moeda(veiculo?.valorFipe)}</strong></div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-around', padding: '6px', background: '#353535', borderRadius: '6px', marginBottom: '8px' }}>
        <span>MENSALIDADE: <strong style={{ color: '#00D594' }}>{moeda(valorMensal || veiculo?.valorMensal)}</strong></span>
        <span>ADESÃO: <strong style={{ color: '#00D594' }}>{moeda(parseFloat(veiculo?.valorFipe) * 0.005)}</strong></span>
      </div>

      <div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
          <tbody>
            {beneficios.map((b, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #444' }}>
                <td style={{ padding: '3px 4px' }}>{b.item}</td>
                <td style={{ padding: '3px 4px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  {b.valor}{b.percentual !== '-' ? ` · ${b.percentual}` : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button
        type="button"
        onClick={onConcordo}
        style={{ width: '100%', marginTop: '10px', padding: '10px', border: 'none', borderRadius: '6px', background: '#4CAF50', color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}
      >
        CONCORDO
      </button>
    </div>
  );
}
